import { render, staticRenderFns } from "./SCardReportSaleComp.vue?vue&type=template&id=3ffd5f46&"
import script from "./SCardReportSaleComp.vue?vue&type=script&lang=js&"
export * from "./SCardReportSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports